// Uberflip GWL OB-7479 code start
function mobileToggleMenu() {
    const menu = document.querySelector('.mobile-click');
    if (menu) {
        menu.addEventListener('click', function(event) {
            event.preventDefault();
            menu.nextElementSibling.classList.toggle('isOpen');
        });
    }
}

export { mobileToggleMenu };
// Uberflip GWL OB-7479 code end


// WEBPACK FOOTER //
// ./script-partials/header.js